import { render, staticRenderFns } from "./MarkCenterRight.vue?vue&type=template&id=37a18e9a&scoped=true&"
import script from "./MarkCenterRight.vue?vue&type=script&lang=js&"
export * from "./MarkCenterRight.vue?vue&type=script&lang=js&"
import style0 from "./MarkCenterRight.vue?vue&type=style&index=0&id=37a18e9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a18e9a",
  null
  
)

export default component.exports